import { Formik } from 'formik'
import numeral from 'numeral'
import { ComponentType, useState } from 'react'
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Label,
  Row,
} from 'reactstrap'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { hasFilters } from 'utils/filters'
import { Filter } from 'views/search/filter'

const Body = styled.div`
  padding: 20px;

  ${up('sm')} {
    padding: 32px;
    width: 460px;
  }
`

interface Props {
  query: any
  disabled: boolean
  onSubmit: (changes: any) => void
}

export const Budget: ComponentType<Props> = ({ query, disabled, onSubmit }) => {
  const [isOpen, setIsOpen] = useState(false)
  const handleToggle = () => setIsOpen(!isOpen)

  const initialValues = {
    'amount>': query['amount>'] ?? '',
    'amount<': query['amount<'] ?? '',
  }

  const resetValues = {
    'amount>': '',
    'amount<': '',
  }

  return (
    <Filter
      label="Precio"
      disabled={disabled}
      isOpen={isOpen}
      isActive={hasFilters(initialValues)}
      onToggle={handleToggle}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => {
          onSubmit(values)
          handleToggle()
        }}
      >
        {({ values, handleBlur, handleChange, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Body>
              <Row form>
                <Col xs={6}>
                  <FormGroup className="mb-0">
                    <Label htmlFor="amount>">Mínimo</Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText className="px-2">$</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="amount>"
                        id="amount>"
                        value={values['amount>'] ? numeral(values['amount>']).format('0,0') : ''}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          if (event.target.value) {
                            event.target.value = numeral(event.target.value).value().toString()
                          }
                          handleChange(event)
                        }}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
                <Col xs={6}>
                  <FormGroup className="mb-0">
                    <Label htmlFor="amount<">Máximo</Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText className="px-2">$</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        name="amount<"
                        id="amount<"
                        value={values['amount<'] ? numeral(values['amount<']).format('0,0') : ''}
                        onBlur={handleBlur}
                        onChange={(event) => {
                          if (event.target.value) {
                            event.target.value = numeral(event.target.value).value().toString()
                          }
                          handleChange(event)
                        }}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>
              </Row>
            </Body>
            <div className="border-top border-athens-gray py-15 px-30 d-flex justify-content-between">
              <Button
                type="button"
                color="link"
                className="p-0 text-raven"
                onClick={() => {
                  onSubmit(resetValues)
                  handleToggle()
                }}
              >
                Borrar
              </Button>
              <Button type="submit" color="link" className="p-0">
                Aplicar
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </Filter>
  )
}
